/** The status of an Span. */
// eslint-disable-next-line import/export
export var SpanStatus;

(function (SpanStatus) {
  /** The operation completed successfully. */
  SpanStatus["Ok"] = "ok";
  /** Deadline expired before operation could complete. */

  SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
  /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */

  SpanStatus["Unauthenticated"] = "unauthenticated";
  /** 403 Forbidden */

  SpanStatus["PermissionDenied"] = "permission_denied";
  /** 404 Not Found. Some requested entity (file or directory) was not found. */

  SpanStatus["NotFound"] = "not_found";
  /** 429 Too Many Requests */

  SpanStatus["ResourceExhausted"] = "resource_exhausted";
  /** Client specified an invalid argument. 4xx. */

  SpanStatus["InvalidArgument"] = "invalid_argument";
  /** 501 Not Implemented */

  SpanStatus["Unimplemented"] = "unimplemented";
  /** 503 Service Unavailable */

  SpanStatus["Unavailable"] = "unavailable";
  /** Other/generic 5xx. */

  SpanStatus["InternalError"] = "internal_error";
  /** Unknown. Any non-standard HTTP status code. */

  SpanStatus["UnknownError"] = "unknown_error";
  /** The operation was cancelled (typically by the user). */

  SpanStatus["Cancelled"] = "cancelled";
  /** Already exists (409) */

  SpanStatus["AlreadyExists"] = "already_exists";
  /** Operation was rejected because the system is not in a state required for the operation's */

  SpanStatus["FailedPrecondition"] = "failed_precondition";
  /** The operation was aborted, typically due to a concurrency issue. */

  SpanStatus["Aborted"] = "aborted";
  /** Operation was attempted past the valid range. */

  SpanStatus["OutOfRange"] = "out_of_range";
  /** Unrecoverable data loss or corruption */

  SpanStatus["DataLoss"] = "data_loss";
})(SpanStatus || (SpanStatus = {})); // eslint-disable-next-line @typescript-eslint/no-namespace, import/export


(function (SpanStatus) {
  /**
   * Converts a HTTP status code into a {@link SpanStatus}.
   *
   * @param httpStatus The HTTP response status code.
   * @returns The span status or {@link SpanStatus.UnknownError}.
   */
  function fromHttpCode(httpStatus) {
    if (httpStatus < 400) {
      return SpanStatus.Ok;
    }

    if (httpStatus >= 400 && httpStatus < 500) {
      switch (httpStatus) {
        case 401:
          return SpanStatus.Unauthenticated;

        case 403:
          return SpanStatus.PermissionDenied;

        case 404:
          return SpanStatus.NotFound;

        case 409:
          return SpanStatus.AlreadyExists;

        case 413:
          return SpanStatus.FailedPrecondition;

        case 429:
          return SpanStatus.ResourceExhausted;

        default:
          return SpanStatus.InvalidArgument;
      }
    }

    if (httpStatus >= 500 && httpStatus < 600) {
      switch (httpStatus) {
        case 501:
          return SpanStatus.Unimplemented;

        case 503:
          return SpanStatus.Unavailable;

        case 504:
          return SpanStatus.DeadlineExceeded;

        default:
          return SpanStatus.InternalError;
      }
    }

    return SpanStatus.UnknownError;
  }

  SpanStatus.fromHttpCode = fromHttpCode;
})(SpanStatus || (SpanStatus = {}));